/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserFlagsModeratorControllerCreateMutationRequest,
  UserFlagsModeratorControllerCreateMutationResponse,
  UserFlagsModeratorControllerCreate401,
} from '../types/UserFlagsModeratorControllerCreate.ts';

function getUserFlagsModeratorCreateUrl() {
  const res = { method: 'POST', url: `/api/moderator/user-flags` as const };
  return res;
}

/**
 * {@link /api/moderator/user-flags}
 */
export async function userFlagsModeratorCreate(
  data: UserFlagsModeratorControllerCreateMutationRequest,
  config: Partial<RequestConfig<UserFlagsModeratorControllerCreateMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UserFlagsModeratorControllerCreateMutationResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerCreate401>,
    UserFlagsModeratorControllerCreateMutationRequest
  >({ method: 'POST', url: getUserFlagsModeratorCreateUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
